var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":`M ${_vm.lw/2} ${_vm.lw/2} h${_vm.L*_vm.W-_vm.lw/2} v${_vm.W-_vm.L*_vm.W-_vm.lw/2} h${_vm.W-_vm.L*_vm.W-_vm.lw/2} v${_vm.L*_vm.W-_vm.lw/2} h-${_vm.W-_vm.lw} v-${_vm.W-_vm.lw}Z`,"stroke-width":_vm.lw,"stroke-dasharray":"400","stroke-dashoffset":1200-_vm.progress*400-_vm.progress2*400}})
}
var staticRenderFns = []

export { render, staticRenderFns }